import { flexbox } from "@material-ui/system";

export default () => ({
  labelContainer: {
    padding: "10px 0px"
  },
})